<template>
  <div class="search-setting">
    <div class="left">
      <label>基本信息</label>
      <div class="top">
        <SimpleTable
          :allowMultiSelect="false"
          :show-index="false"
          ref="baseTop"
          :menusMergeAfter="menusMergeAfterBaseTop"
          :columns="columnsBaseTop"
          :data="tableDataBaseTop"
        />
      </div>
      <div class="bottom">
        <SimpleTable
          :show-index="false"
          ref="baseBottom"
          :menusMergeAfter="menusMergeAfterBaseBottom"
          :columns="columnsBaseBottom"
          :data="tableDataBaseBottom"
          @modify-data-change="handleModifyDataChangeBaseBottom"
        />
      </div>
    </div>
    <div class="right">
      <label>工程概况</label>
      <div class="box">
        <div class="box-left">
          <SimpleTable
            :allowMultiSelect="false"
            :show-index="false"
            ref="projectLeftTop"
            :columns="columnsProjectLeftTop"
            :data="tableDataProjectLeftTop"
            @row-select="handleRowSelectProjectLeftTop"
          />
        </div>
        <div class="box-right">
          <div class="top">
            <SimpleTable
              :allowMultiSelect="false"
              :show-index="false"
              ref="projectTop"
              :columns="columnsProjectTop"
              :data="tableDataProjectTop"
            />
          </div>
          <div class="bottom">
            <SimpleTable
              :show-index="false"
              ref="projectBottom"
              :columns="columnsProjectBottom"
              :data="tableDataProjectBottom"
              @modify-data-change="handleModifyDataChangeProjectBottom"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'
import dayjs from 'dayjs'

export default {
  name: 'SearchSetting',
  components: { SimpleTable },
  data() {
    return {
      // 页面数据
      columnsBaseTop: [
        {
          field: 'name',
          title: '基本信息',
          width: 100
        },
        {
          field: 'desc',
          title: '特征描述值',
          width: 200,
          canModify: true
        }
      ],
      columnsBaseBottom: [
        {
          field: 'name',
          title: '基本参数',
          width: 150
        },
        {
          field: 'top',
          title: '上限',
          width: 150,
          fieldType: 'number',
          canEdit: true,
          canModify: true
        },
        {
          field: 'bottom',
          title: '下限',
          width: 150,
          fieldType: 'number',
          canEdit: true,
          canModify: true
        }
      ],
      columnsProjectLeftTop: [
        {
          field: 'name',
          title: '工程分类',
          width: 100
        }
      ],
      columnsProjectTop: [
        {
          field: 'name',
          title: '基本信息',
          width: 100
        },
        {
          field: 'desc',
          title: '特征描述值',
          width: 200,
          editModal: {
            columns: [{ field: 'name', title: '特征描述值' }],
            options: () => this.getEngineeringFeatureOptions(),
            allowMultiSelect: true,
            confirm: (selectedCellInfos, res) => {
              const arr = res.map(e => e[0].originData)
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'desc', arr.map(e => e.name).join(' '))
                this.$set(obj, 'value', arr)
              })
            }
          },
          canModify: true
        }
      ],
      columnsProjectBottom: [
        {
          field: 'name',
          title: '工程参数',
          width: 200
        },
        {
          field: 'top',
          title: '上限',
          width: 200,
          fieldType: 'number',
          canEdit: true,
          canModify: true
        },
        {
          field: 'bottom',
          title: '下限',
          width: 200,
          fieldType: 'number',
          canEdit: true,
          canModify: true
        }
      ],

      tableDataBaseTop: [
        { code: 'dxgcmc', name: '单项工程名称', desc: '' },
        { code: 'gclx', name: '工程类型', desc: '' },
        { code: 'szdq', name: '所在地区', desc: '' },
        { code: 'xxdz', name: '详细地址', desc: '' }
      ],
      tableDataBaseBottom: [
        { code: 'jzgm', name: '建筑规模', top: '', bottom: '' },
        { code: 'zjzj', name: '直接费造价', top: '', bottom: '' },
        { code: 'zzj', name: '总造价', top: '', bottom: '' },
        { code: 'kssj', name: '开始时间', top: '', bottom: '' },
        { code: 'jssj', name: '结束时间', top: '', bottom: '' },
        { code: 'gq', name: '工期(天)', top: '', bottom: '' }
      ],
      tableDataProjectLeftTop: [],
      tableDataProjectTop: [],
      tableDataProjectBottom: []
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    menusMergeAfterBaseTop(contextMenuMap) {
      contextMenuMap['批量修改'] = () => this.handleEditBaseTop()
    },

    async handleEditBaseTop() {
      const rows = this.$refs.baseTop.getSelectData()
      const obj = rows[0]?.[0]?.originData
      if (['dxgcmc', 'xxdz'].includes(obj.code)) {
        // 输入
        this.$selectModal({
          title: obj.name,
          type: 'input',
          confirm: res => {
            obj.desc = res
          }
        })
      } else {
        // 下拉
        const options = await this.getBaseOptions(obj.code)
        this.$selectModal({
          title: obj.name,
          columns: [{ field: 'name', title: obj.name, tree: true }],
          options: options,
          allowMultiSelect: obj.code === 'szdq',
          confirm: (selectedCellInfos, res) => {
            // if (obj.code === 'gclx') {
            // if (selectedCellInfos?.[0][0].originData.children?.length) {
            //   this.$message.warning('请选择叶子节点')
            //   return Promise.reject('请选择叶子节点')
            // }
            // }
            const arr = selectedCellInfos.map(e => e[0].originData)
            obj.desc = arr.map(e => e.name).join(' ')
            obj.value = arr

            if (obj.code === 'gclx') {
              this.getTableDataProjectLeftTop(arr)
            }
          }
        })
      }
    },

    async getBaseOptions(code) {
      const map = {
        gclx: '/engineering-classify/listAllClassify',
        szdq: '/region/list'
      }
      const res = await this.$service.get(map[code], {})
      return sortRecords(res?.data || [])
    },

    async getTableDataProjectLeftTop(arr) {
      this.tableDataProjectLeftTop = []
      if (!arr?.length) return
      const res = await this.$service.get(
        '/projectUnitengineering-classify/listAllClassify',
        {
          projectUnitId: arr[0].id
        }
      )
      this.tableDataProjectLeftTop = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.projectLeftTop.initialized()
    },
    async getTableDataProjectTop(obj) {
      this.tableDataProjectTop = []
      if (!obj?.id) return
      const res = await this.$service.get(
        '/projectUnitEngineeringFeature/queryList',
        { engineeringClassifyId: obj.id }
      )
      this.tableDataProjectTop = sortRecords(
        res?.data.map(e => ({ ...e, desc: '' })) || []
      )
    },

    async getTableDataProjectBottom(obj) {
      this.tableDataProjectBottom = []
      if (!obj?.id) return
      const res = await this.$service.get(
        '/projectUnitEngineeringParam/queryList',
        { engineeringClassifyId: obj.id }
      )
      this.tableDataProjectBottom = sortRecords(
        res?.data.map(e => ({ ...e, top: '', bottom: '' })) || []
      )
    },

    async getEngineeringFeatureOptions() {
      const rows = this.$refs.projectTop.getSelectData()
      const obj = rows[0]?.[0]?.originData
      const res = await this.$service.get(
        '/engineering-classify/feature-values',
        {
          featureId: obj.id
        }
      )
      return sortRecords(res?.data || [])
    },

    menusMergeAfterBaseBottom(contextMenuMap) {
      contextMenuMap['批量修改'] = () => this.handleEditBaseBottom()
    },

    handleEditBaseBottom() {
      const rows = this.$refs.baseBottom.getSelectData()
      const obj = rows[0]?.[0]?.originData
      const prop = rows[0]?.[0].field
      if (obj.name.includes('时间')) {
        this.$selectModal({
          title: obj.name,
          type: 'date',
          confirm: res => {
            obj[prop] = res
          }
        })
      } else {
        this.$selectModal({
          title: obj.name,
          type: 'number',
          confirm: res => {
            obj[prop] = res
          }
        })
      }
    },

    handleModifyDataChangeBaseBottom(getModifyData) {
      const arr = getModifyData()
      for (const obj of arr) {
        if (obj.name.includes('时间')) {
          const isDate = str => /^\d{4}-\d{2}-\d{2}$/.test(str)
          if (obj.top && !isDate(obj.top)) {
            this.$message.warning('请输入正确的日期,可以使用右键修改')
            obj.top = ''
          }
          if (obj.bottom && !isDate(obj.bottom)) {
            this.$message.warning('请输入正确的日期,可以使用右键修改')
            obj.bottom = ''
          }
        }
      }
    },

    handleModifyDataChangeProjectBottom() {},

    handleRowSelectProjectLeftTop(rows) {
      const obj = rows[0]?.[0]?.originData
      this.getTableDataProjectTop(obj)
      this.getTableDataProjectBottom(obj)
    },

    getData() {
      return {
        tableDataBaseTop: this.tableDataBaseTop,
        tableDataBaseBottom: this.tableDataBaseBottom,
        tableDataProjectTop: this.tableDataProjectTop,
        tableDataProjectBottom: this.tableDataProjectBottom
      }
    }
  }
}
</script>

<style scoped lang="less">
.search-setting {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  height: 382px;
  overflow: hidden;
  > div {
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    align-items: flex-start;
    gap: 8px;
    height: 100%;
    > div {
      width: 100%;
    }
  }
  label {
    text-align: center;
    width: 100%;
  }
  .left {
    flex: 0.4;
    .top {
      height: 144px;
    }
    .bottom {
      height: 200px;
    }
  }
  .right {
    flex: 0.6;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;

    .box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 10px;
      height: 100%;
      .box-left {
        flex: 0.4;
        height: 100%;
      }
      .box-right {
        flex: 0.6;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px;
        > div {
          width: 100%;
          flex: 1;
        }
      }
    }
  }
}
</style>
